import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuxiliarService } from 'src/app/_services/auxiliar.service';
import { ViajesService } from 'src/app/_services/viajes.service';
import { ToursService } from '../../_services/tours.service';

@Component({
  selector: 'app-modal-asientos',
  templateUrl: './modal-asientos.component.html',
  styleUrls: ['./modal-asientos.component.css']
})
export class ModalAsientosComponent implements OnInit {

  tipoTransporte:number;

  id:number;

  passAsientos:string;
  asientosSelected:string;

  bdTransporte: any;
  transporteText:string;

  constructor(public activeModal: NgbActiveModal, private viajesService: ViajesService, private auxService: AuxiliarService, private tourservice: ToursService) { }

  ngOnInit(): void {
    if(this.tipoTransporte == 1){
      this.transporteText = 'Bus mix';
    }else if(this.tipoTransporte == 2){
      this.transporteText = 'Bus semi cama';
    }else if(this.tipoTransporte == 3){
      this.transporteText = 'Minibus';
    }
    this.viajesService.getTipoTransporte().subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        var response = data.body;
        this.bdTransporte = response;                             
      }
    }); 


    this.tourservice.getReservedSeats(this.id).subscribe(seats=>{
      seats.forEach(element => {
        this.asientosSelected+='*'+element.asientos_reservados;
      });
    })
  }

  salir(){
    this.activeModal.dismiss();
  }

}
